import "react/jsx-runtime";
import { createContext as t, useContext as o } from "react";
const m = {
  theme: "system",
  computedTheme: "light",
  setTheme: () => null
}, r = t(m), n = () => {
  const e = o(r);
  if (e === void 0) throw new Error("useTheme must be used within a Themed");
  return e;
};
export {
  n as k
};
//# sourceMappingURL=use-theme-xHxAHy0N-C40aLO4N.js.map
